import React, { useState } from "react";
import classNames from "classnames";
import EmailQuote from "pu-react/components/EmailQuote";
import EmailImg from 'images/products/project_quote/email.png'
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';


const EmailQuoteButton = ({ handleShow, emailQuoteActive }) => {
  const [showError, setShowError] = useState()

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        Please, select a service
      </Popover.Body>
    </Popover>
  );


  const customHandleShow = (e) => {
    e.preventDefault();
    if (!emailQuoteActive) {
      setShowError(true)
      setTimeout(() => {
        setShowError(false)
      }, "2000")
    } else {
      handleShow();
    }
  }

  return (
    <>
      <img className={`email-icon ${emailQuoteActive ? "active" : ""}`} src={EmailImg} />
      <OverlayTrigger show={showError} rootClose trigger="click" placement="bottom" overlay={popover}>
        <a
          href="#"
          className={`btn-link email-quote-link ${!emailQuoteActive ? "disabled" : ""}`}
          onClick={customHandleShow}>
          Email Quote
        </a>
      </OverlayTrigger>
    </>
  )
}

class CustomEmailQuote extends EmailQuote {

  renderButton() {
    return (
      <EmailQuoteButton
        emailQuoteActive={this.props.emailQuoteActive}
        handleShow={this.handleShow} />
    );
  }
}

export default CustomEmailQuote;
